import React from "react";
import { STATUS_LABELS, STATUS_COLORS } from "@/pages/onboarding/constants";

export default function WorkflowBadge({ status, testId }) {
  const cfg = STATUS_COLORS[status] || { color: "#94A3B8", bg: "#94A3B814" };
  return (
    <span
      data-testid={testId || `workflow-status-${status}`}
      className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap"
      style={{ background: cfg.bg, color: cfg.color }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: cfg.color }} />
      {STATUS_LABELS[status] || status}
    </span>
  );
}
